import { API_MODULE_HORIZONTAL_SIGNING, useHorizontalSigningProject } from "@l2r-front/l2r-app-city"

export function useModuleProjectTags(campaignType: string | undefined): string[] | undefined {

    const { data: horizontalSigningProject } = useHorizontalSigningProject({ enabled: campaignType === API_MODULE_HORIZONTAL_SIGNING })

    return horizontalSigningProject?.tags
}
